import {
    SmartHttp
} from '@/utils'

// let urls = publicMethod.getUrls();
const request = new SmartHttp({
    baseURL: process.env.VUE_APP_GATEWAY
}).request;
export const srcUrl = `${process.env.VUE_APP_WZ}/upload/getImagesByTitle?session=`
export const headerSrcUrl = `${process.env.VUE_APP_WZ}/upload/getImages?session=`
export const videoUrl = `${process.env.VUE_APP_WZ}/upload/downloadVideo?session=`
// export const baseURL = process.env.VUE_APP_GATEWAY
export const httpService = {
    // 获取新闻列表
    getNewsList: (params) => {
        return request.post('/news/view/getNewsList', params);
    },
    // 老版新闻列表及详情
    getoldNewsList: (params) => {
        return request.post('/showJournalism/getNewsList', params);
    },
    getoldNewsDetails: (params) => {
        return request.post('/showJournalism/getNews/' + params)
    },

    // 获取首页轮播
    getSwipeList: () => {
        return request.get('/news/view/newsTickers');
    },
    // 新闻列表详情页
    getNewsDetails: (params) => {
        return request.get('/news/view/getNews?pressId=' + params)
    },
    // 切换灰色背景
    getGray: () => {
        return request.get('/edoPermission/user/getBlackAndWhite')
    },

    // echarts
    getBarEcharts(userId) {
        return request.get(`CorpIndicator/getScoreDetail?userId=${userId}`)
    },
    getEcharts: () => {
        return request.get('/CorpIndicator/getIndicatorDetailScore')
    },
    // 注册
    registFn: (params) => {
        return request.post('/edoPermission/auths/register', params);
    },
    // 验证码
    phoneCodeFn: (params) => {
        return request.get(`/edoSendSmsVerify/SendSms/getSmsRegister/${params}`);
    },
    // 登录验证码
    loginCodeFn: (params) => {
        return request.get(`/edoSendSmsVerify/SendSms/getSmsLogin/${params}`);
    },
    // 登录
    loginFn: (params) => {
        return request.post('/edoPermission/login/login', params);
    },
    // 培训课程相关接口
    // 新增报名
    addCoursePerson: (params) => {
        return request.post('/edoCouresGrop/coures/addCoursePerson', params);
    },
    // 取消报名
    deleteCoursePerson: (params) => {
        return request.post('/edoCouresGrop/coures/addCoursePerson', params);
    },
    // 测评相关接口
    // 查看分数
    lookScoreFn: (params) => {
        return request.post(`/CorpIndicator/showScore/${params}`);
    },
    // 获取服务项目
    getIndicatorServiceFn: () => {
        return request.post(`/CorpIndicator/getIndicatorService`);
    },
    // 已选择的服务
    getchoiceIndicatorService: () => {
        return request.post(`/CorpIndicator/getchoiceIndicatorService`);
    },
    getIndicatorServiceAll: () => {
        return request.post(`/CorpIndicator/getIndicatorServiceAll`);
    },
    // 删除已选择的服务
    deleteChoiceIndicatorService: (params) => {
        return request.post(`/CorpIndicator/deleteChoiceIndicatorService/${params}`);
    },
    // Ajuan
    // 测评提交
    addScoreHomeFn: (params) => {
        return request.post(`/CorpIndicator/addScore/26/2`, params);
    },
    // 存为草稿
    addDraftFn: (params) => {
        return request.post(`/CorpIndicator/addScore/26/1`, params);
    },
    backfillHomeFormFn: () => {
        return request.post("/CorpIndicator/getCorpIndicatorOption/26");
    },
    // B测评提交
    addScore: (id,params) => {
        return request.post(`/CorpIndicator/addScore/${id}/2`, params);
    },
    // B数据回填
    getCorpIndicatorOption: (id) => {
        return request.post(`/CorpIndicator/getCorpIndicatorOption/${id}`);
    },
    // 测评已保存的服务
    getSavedTableB: () =>{
        return request.post(`/CorpIndicator/getSavedTableB`);
    },
    // 保存测评
    saveB: (id,params) => {
        return request.post(`CorpIndicator/saveTableB/${id}`,params);
    },
    // echarts
    getEcharts: () => {
        return request.get('/CorpIndicator/getIndicatorDetailScore')
    },
    getBarEcharts(userId) {
        return request.get(`CorpIndicator/getScoreDetail?userId=${userId}`)
    },
    // 获取测评list
    getIndicatorCorpList: (params) => {
        return request.post(`CorpIndicator/getIndicatorCorpList`, params);
    },
    // 上传材料
    uploadAuditFile: (params) => {
        return request.post(`CorpIndicator/uploadAuditFile`, params);
    },

    // 申请如何相关接口
    // 数据字典
    dataDictionary: (params) => {
        return request.get("/edoPermission/dic/getDistList", params);
    },
    // 申请入会
    addApply: (params) => {
        return request.post(`/member/joinProcess/startProcess`, params);
    },
    // 获取信息
    getmemberInfo: (params) => {
        return request.get(`/member/joinProcess/getInfo?userId=${params}`);
    },
    //没有登录时的获取信息
    getmemberInfo2: (params) => {
        return request.get(`/edoPermission/CorpInfo/getCorpInfoAll?userId=${params}`);
    },
    // 下载入会申请书
    uploadApplyMem: (params) => {
        return request.get(`/member/joinProcess/uploadApplyMem?userId=${params}`);
    },
    // 获取省
    getProvince: () => {
        return request.get(`/edoPermission/dic/getProvince`);
    },
    // 市
    getCity: (params) => {
        return request.get(`/edoPermission/dic/getCity?province=${params}`);
    },
    // 县
    getArea: (params) => {
        return request.get(`/edoPermission/dic/getArea?city=${params}`);
    },
    // 文件上传
    // 图片上传
    addfile: (params) => {
        
        let headers = {
            headers: {
                'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq'
            }
        };

        return request.post('/upload/addfile', params, headers);
    },
    // 课程相关接口
    // 课程列表
    getCourseList: (params) => {
        return request.post(`/edoCoures/coures/getCourseListNew`, params);
    },
    // 课程报名新增
    addCoursePerson: (params) => {
        return request.post(`/edoCouresGrop/coures/addCoursePerson`, params);
    },
    // 获取课程详细信息
    getTrainCourse: (params) => {
        return request.get(`/edoCoures/coures/getTrainCourse?trainId=${params}`);
    },
    // 下载课程文件
    filedownload: (params, params2) => {
        return request.get(`/upload/download?session=${params}${'&fileName='}${params2}`);
    },
    // 已报名课程
    getJoinCourse1: (params) => {
        return request.post(`/edoCoures/coures/getCompleteCouresNew`, params);
    },
    // 已完成课程1
    getJoinCourse2: (params) => {
        return request.post(`/edoCoures/coures/getCompleteCourse`, params);
    },
    // 查看报名人员信息
    getCoursePersonByCorp: (params) => {
        return request.post(`/edoCoures/coures/selectAllBusTrain/${params}`);
    },
    // 会议相关接口
    getconfereeList: (params) => {
        return request.post(`/edoCoures/conferenceNew/getconfereeList`, params);
    },
    // 获取会议详情
    getConferee: (params) => {
        return request.get(`/edoCoures/conferenceNew/getConferee?conferenceId=${params}`);
    },
    // 获取会议表单配置项
    getTemplateOption: (params) => {
        return request.get(`/edoCoures/conferenceTemplate/getTemplateOption?confereeCode=${params}`);
    },
    // 保存会议报名
    addConference: (params) => {
        return request.post(`/edoCoures/conferenceNew/addConference`, params);
    },
    //    消息通知
    NotificationList: (params) => {
        return request.post(`/edoPermission/notification/NotificationList`, params);
    },
    // 获取是否会员、信息审核状态
    getCorpInfoOther: (params) => {
        return request.get(`/edoPermission/CorpInfo/getCorpInfoOther?userId=${params}`);
    },
    // 用户信息编辑
    updateUserInfo: (params) => {
        return request.post(`/member/infoAudit/updateUserInfo`, params);
    },
    // 会员信息发布栏目
    getALLColumn: () => {
        return request.get(`/edoPermission/PullDown/getALLColumn?typeId=43`);
    },
    // 保存
    addNews: (params) => {
        return request.post(`/news/addNews`, params);
    },
    // 新闻列表
    membergetNewsList: (params) => {
        return request.post(`/news/getNewsList`, params);
    },
    // 获取新闻详情
    membergetNews: (params) => {
        return request.get(`/news/view/getNews?pressId=${params}`);
    },
    // 修改新闻
    updateNews: (params) => {
        return request.post(`/news/updateNews`, params);
    },
    // 删除新闻
    delectNew: (params) => {
        return request.get(`/news/delectNew?pressId=${params}`);
    },
    // 会费缴纳列表
    getDuesLog: (params) => {
        return request.post(`/member/DuesBill/getDuesLog`, params);
    },
    // 用戶添加电子发票
    addDuesBill: (params) => {
        return request.post(`/member/DuesBill/addDuesBill`, params);
    },
    // 查看发票
    getBill: (params) => {
        return request.get(`/edoPermission/bill/getBill?billId=${params}`);
    },
    // 课程取消报名
    delBusTrainInfos: (params) => {
        return request.post(`/edoCoures/coures/delBusTrainInfos`, params);
    },
    // 修改课程
    updateTrainInfos: (params) => {
        return request.post(`/edoCoures/coures/updateTrainInfos`, params);
    },
    // 查看人员课程报已完成信息
    completeCoursePerson: (userId, trainId) => {
        return request.post(`/edoCoures/coures/completeCoursePerson/${userId}/${trainId}`);
    },
    // 用户登录记录/edoPermission/user/getUserLog
    getUserLog: (params) => {
        return request.post(`/edoPermission/user/getUserLog`, params);
    },
    // 会员服务
    findMember: (params) => {
        return request.post(`member/memberManage/findMember`, params);
    },
    // 领军人才课程信息
    getLeaderClass: () => {
        return request.get(`/edoCoures/coures/getLeaderClass`);
    },
    // 头雁课程信息
    getHeadGooesClass: () => {
        return request.get(`/edoCoures/coures/getHeadGooseClass`);
    },
    // 领军人才报名第一步
    addLeaderTalent: (params) => {
        return request.post(`/edoCoures/course/addLeaderTalent`, params);
    },
    GooseaddLeaderTalent: (params) => {
        return request.post(`/edoCoures/course/HeadGoose/addLeaderTalent`, params);
    },
    // 提交审核
    submitLeaderTalent: (params) => {
        return request.post(`/edoCoures/course/submitLeaderTalent`, params);
    },
    GoosesubmitLeaderTalent: (params) => {
        return request.post(`/edoCoures/course/HeadGoose/submitLeaderTalent`, params);
    },
    // 查询领军人才报名信息
    getSingleLeaderTalen:()=>{
        return request.get('/edoCoures/course/getSingleLeaderTalen')
    },
    GoosegetSingleLeaderTalen:()=>{
        return request.get('/edoCoures/course/HeadGoose/getSingleLeaderTalen')
    },
    // 找回修改密码
    resetPassword: (params) => {
        return request.post(`/edoPermission/user/resetPassword`, params);
    },
    // 新闻搜索
    findNewsList: (params) => {
        return request.post(`/news/view/findNewsList`, params);
    },
    // 报名信息查询
    findApply: (params) => {
        return request.post(`/edoCoures/coures/findApply`, params);
    },
    // 成绩和证书查询
    findGrade: (params) => {
        return request.post(`/edoCoures/coures/findGrade`, params);
    },
    // 下载领军人才申请表
    leadFile: () => {
        return request.get(`/edoCoures/coures/getLeaderSelectTable`);
    },
    // 非会员修改账户信息
    updateInfoforCorpInfo: (params) => {
        return request.post(`/edoPermission/CorpInfo/updateInfoforCorpInfo`, params);
    },
    // 获取分支机构-主要负责人
    getNewsContentList: (params) => {
        return request.post(`news/view/getNewsContentList`, params);
    },
    // 账户信息是否能修改
    isInfoaudit: () => {
        return request.get(`/member/infoAudit/isInfoaudit`);
    },
    // 分支机构
    getHeadList(params) {
        return request.post('news/view/getNewsContentList', params)
    },
    // 课程培训完成
    selectGraduationStudent: (params) => {
        return request.post(`/edoCoures/coures/selectGraduationStudentNew`,params);
    },
    // 领军人才培训完成
    LeadGraduationStudent: (params) => {
        return request.post(`/edoCoures/course/getMarkAndCertifateIsLeaderPerson`,params);
    },
    GooseLeadGraduationStudent: (params) => {
        return request.post(`/edoCoures/course/HeadGoose/getMarkAndCertifateIsLeaderPerson`,params);
    },
    // 测评人姓名、电话
    addAppraisalPersonInfo: (params,params1) => {
        return request.get(`/CorpIndicator/addAppraisalPersonInfo?linkName=${params}&phone=${params1}`);
    },
    // 领军人才课程详情接口
    getSingleLeaderTalenById: (params) => {
        return request.get(`/edoCoures/course/getSingleLeaderTalenById?leaderPersonId=${params}`);
    },
    GoosegetSingleLeaderTalenById: (params) => {
        return request.get(`/edoCoures/course/HeadGoose/getSingleLeaderTalenById?leaderPersonId=${params}`);
    },
    // 领军人才审核未通过在提交
    leaderPersonRejectUpdate: (params) => {
        return request.post(`/edoCoures/course/leaderPersonRejectUpdate`,params);
    },
    GooseleaderPersonRejectUpdate: (params) => {
        return request.post(`/edoCoures/course/HeadGoose/leaderPersonRejectUpdate`,params);
    },
    // 修改手机号
    updateRegisterPhone: (params) => {
        return request.get(`edoPermission/CorpInfo/updateRegisterPhone?phone=${params}`);
    },
    // 测评提示文件下载 
    getDefaultFile: () => {
        return request.get(`CorpIndicator/getDefaultFile`);
    },
    // 填写测评人员信息
    getAppraisalPersonInfo: () =>{
        return request.get(`/CorpIndicator/getAppraisalPersonInfo`);
    },
    // 领军人才报名获取用户信息
    selectLeaderPersonNoe: () =>{
        return request.get(`/edoCoures/course/selectLeaderPersonNoe`);
    },
    // 头雁
    GooseselectLeaderPersonNoe: () =>{
        return request.get(`/edoCoures/course/HeadGoose/selectLeaderPersonNoe`);
    },
    // 领军人才开票相关
    commitPayMentVoucher: (params) =>{
        return request.post(`/edoCoures/course/commitPayMentVoucher`,params);
    },
    GoosecommitPayMentVoucher: (params) =>{
        return request.post(`/edoCoures/course/HeadGoose/commitPayMentVoucher`,params);
    },
    getCommitBillAndPay: (params) =>{
        return request.get(`/edoCoures/course/getCommitBillAndPay?leaderPersonId=${params}`);
    },
    GoosegetCommitBillAndPay: (params) =>{
        return request.get(`/edoCoures/course/HeadGoose/getCommitBillAndPay?leaderPersonId=${params}`);
    },
    // 微信登录
    LoginAndRegister: (params) =>{
        return request.get(`/WeChat/LoginAndRegister?code=${params}`);
    },
    isUpdateUserName: (params) =>{
        return request.get(`/WeChat/isUpdateUserName?userId=${params}`);
    },
    updateUserName: (params) =>{
        return request.post(`/WeChat/updateUserName`,params);
    },
    // 判断是否绑定微信
    isWeChatBinding: (params) =>{
        return request.get(`/WeChat/isWeChatBinding?userId=${params}`);
    },
    // 绑定微信
    weChatBindingUser: (params,params1) =>{
        return request.get(`/WeChat/weChatBindingUser?code=${params}&state=${params1}`);
    },
    // 解绑
    weChatNnbundle: (params) =>{
        return request.get(`/WeChat/weChatNnbundle?userId=${params}`);
    },
    // MBA
    findThirdPartyCourse: (params) =>{
        return request.post(`/edoCoures/coures/findThirdPartyCourse`,params);
    },
    // 课程配置报名信息
    getApplyList: (params, id) => {
        return request.get(`/edoCoures/busApply/getApplyList?trainId=${params}&userId=${id}`);
    },
    // 课程信息
    getSingleBusCourse: (params) => {
        return request.get(`/edoCoures/coures/getTrainCourse?trainId=${params}`)
    },
    addApplyPerson: (params) => {
        return request.post('/edoCoures/busApply/addApplyPerson', params);
    },
    addbusBill: (params) => {
        return request.post('/edoCoures/busBill/addbusBill', params);
    },
    isApplyOfPerson: (params, id) => {
        return request.get(`/edoCoures/busApply/isApplyOfPerson?trainId=${params}&userId=${id}`);
    },
    getbusBillInfo: (params, id) => {
        return request.get(`/edoCoures/busBill/getbusBillInfo?trainId=${params}&userId=${id}`);
    },
    isAddBill: (params, id) => {
        return request.get(`/edoCoures/busApply/isAddBill?trainId=${params}&userId=${id}`);
    },
    addVoucher: (params) => {
        return request.post('/edoCoures/busApply/addVoucher', params);
    },
    isHaveVoucher: (params, id) => {
        return request.get(`/edoCoures/busApply/isHaveVoucher?trainId=${params}&userId=${id}`);
    },
    getVoucher: (params, id) => {
        return request.get(`/edoCoures/busApply/getVoucher?trainId=${params}&userId=${id}`);
    },
    // 取消报名
    deleteApply: (params, id) => {
        return request.get(`/edoCoures/busApply/deleteApply?trainId=${params}&userId=${id}`);
    },
    // 专家库列表（全部）
    beforestageExpertList: (params) => {
        return request.post('/edoPermission/expert/beforestageExpertList', params);
    },
    // 专家库列表（个人）
    getbackstageExpertList: (params) => {
        return request.post('/edoPermission/expert/getbackstageExpertList', params);
    },
    
    // 新增专家库
    insertExpert: (params) => {
        return request.post('/edoPermission/expert/insertExpert', params);
    },
     // 修改专家库
     updateExpert: (params) => {
        return request.post('/edoPermission/expert/updateExpert', params);
    },
    // 专家详情
    getSingleBusexpertById: (expertId) => {
        return request.get(`/edoPermission/expert/getSingleBusexpertById?expertId=${expertId}`);
    },
    // 删除
    deletBusexpertById: (expertId) => {
        return request.get(`/edoPermission/expert/deletBusexpertById?expertId=${expertId}`);
    },
    //机构名录
    // 柱状
    getScoreDetail: (id) => {
        return request.get(`CorpIndicator/getScoreDetail?userId=${id}`);
    },
    // 雷达
    getIndicatorDetailScore: (id) => {
        return request.get(`CorpIndicator/getIndicatorDetailScore?userId=${id}`);
    },
    
















}